import { BaseApiService } from "../base/base-api.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CustomErrorHandlerService } from '../custom-error-handler.service';
import { PreferencePage } from '../../../models/preference-page/preference-page.model';
import { PreferencePageSerializer } from '../../../models/preference-page/preference-page-serializer.class';

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class PreferencePageService extends BaseApiService<PreferencePage> {
  constructor(httpClient: HttpClient) {
    super(
        httpClient, 
        null, 
        "preferencepages", 
        new PreferencePageSerializer(), 
        new CustomErrorHandlerService());
    }
    
    // Method to get the HTML content for viewing in a new tab
    getViewHtml(preferencePageId: string, tenantId: string): Observable<string> {
        return this.httpClient.get(`${this.url}/preferencepages/render/${preferencePageId}`, {
            params: { tenantId: tenantId },
            responseType: 'text'  // Set responseType to 'text' to get plain HTML string
        });
    }

    // Method to get the HTML content for preview
    getPreviewHtml(preferencePageId: string, tenantId: string): Observable<string> {
        return this.httpClient.get(`${this.url}/preferencepages/render/${preferencePageId}`, {
            params: { tenantId: tenantId },
            responseType: 'text'  // Set responseType to 'text' to get plain HTML string
        });
    }

    getEmbedCode(preferencePageId: string): Observable<any> {
        return this.httpClient.get(`${this.url}/preferencepages/${preferencePageId}/embed-code`);
    }
}
